import type { StoreReconciliationAuditShiftModel } from "models";

export interface ShiftDisplayLabelRow {
  shift: StoreReconciliationAuditShiftModel;
  displayLabel: string;
  locationLabel: string;
  shiftNumber: number;
}

const getShiftLocationKey = (shift: StoreReconciliationAuditShiftModel) =>
  String(shift.locationKey || shift.locationType || shift.locationName || "").trim().toLowerCase();

const formatShiftLocationLabel = (shift: StoreReconciliationAuditShiftModel) => {
  return String(shift.locationName || shift.locationKey || shift.locationType || "").trim();
};

export const buildShiftDisplayLabelRows = (
  shifts: StoreReconciliationAuditShiftModel[],
  options?: {
    resetByReportDate?: boolean;
  }
): ShiftDisplayLabelRow[] => {
  const seenByGroup = new Map<string, number>();

  return shifts.map((shift) => {
    const locationLabel = formatShiftLocationLabel(shift);
    const groupKey = `${options?.resetByReportDate ? `${shift.reportDate || ""}::` : ""}${getShiftLocationKey(shift)}`;
    const shiftNumber = (seenByGroup.get(groupKey) ?? 0) + 1;

    seenByGroup.set(groupKey, shiftNumber);

    return {
      shift,
      displayLabel: `Shift ${shiftNumber}`,
      locationLabel,
      shiftNumber,
    };
  });
};
